var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98825 16.1157C1.4376 16.1157 0.968566 15.922 0.58114 15.5346C0.193713 15.1472 0 14.6781 0 14.1275V3.5094C0 2.95293 0.193713 2.47892 0.58114 2.08736C0.968566 1.69579 1.4376 1.5 1.98825 1.5H15.9906C16.5471 1.5 17.0211 1.69579 17.4126 2.08736C17.8042 2.47892 18 2.95293 18 3.5094V14.1275C18 14.6781 17.8042 15.1472 17.4126 15.5346C17.0211 15.922 16.5471 16.1157 15.9906 16.1157H1.98825ZM8.98942 9.66451C9.08813 9.66451 9.17979 9.65041 9.26439 9.62221C9.349 9.59401 9.44164 9.55135 9.5423 9.49424L15.6945 5.37074C15.765 5.33549 15.832 5.26674 15.8954 5.16451C15.9589 5.06228 15.9906 4.94584 15.9906 4.81519C15.9906 4.57029 15.8743 4.36899 15.6416 4.21129C15.4089 4.05359 15.1727 4.05934 14.933 4.22855L8.98942 8.12045L3.06698 4.22855C2.82726 4.07344 2.58754 4.05934 2.34783 4.18625C2.10811 4.31316 1.98825 4.51651 1.98825 4.79628C1.98825 4.92128 2.0235 5.03416 2.09401 5.13494C2.16451 5.23574 2.23635 5.31479 2.30952 5.37212L8.43699 9.49426C8.53736 9.55136 8.62985 9.59401 8.71445 9.62221C8.79906 9.65041 8.89072 9.66451 8.98942 9.66451Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmail);
export default __webpack_public_path__ + "static/media/login_email.a647f766cff15724ac1ed925f6e0b687.svg";
export { ForwardRef as ReactComponent };